import { render } from "./TabsLayout.vue?vue&type=template&id=39b97661"
import script from "./TabsLayout.vue?vue&type=script&lang=js"
export * from "./TabsLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__